import * as React from 'react';
import { IProject, IUser } from '../model';

interface IGlobalContext {
  isCreating: boolean;
  user: IUser | null;
  project?: IProject;
  toggleIsCreating: () => void;
  updateProject: (project: IProject) => void;
  updateUser: (logout?: boolean) => void;
}

export interface IGlobalContextProps {
  context: IGlobalContext;
}

export const defaultGlobalContext: IGlobalContext = {
  isCreating: false,
  toggleIsCreating: () => {
    return;
  },
  updateProject: () => {
    return;
  },
  updateUser: () => {
    return;
  },
  user: null,
};

export const GlobalContext = React.createContext<IGlobalContext>(
  defaultGlobalContext
);

type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export function withGlobalContext<P extends IGlobalContextProps>(
  Component: React.ComponentType<P>
) {
  return function withGlobalContextComponent(
    props: Omit<P, keyof IGlobalContextProps>
  ) {
    return (
      <GlobalContext.Consumer>
        {(context) => <Component {...props} context={context} />}
      </GlobalContext.Consumer>
    );
  };
}



// WEBPACK FOOTER //
// ./src/context/global.context.tsx